import React from 'react';
import ReactTooltip, { TooltipProps as ReactTooltipProps } from 'react-tooltip';
import classNames from 'classnames';

export type TooltipProps = ReactTooltipProps;

export const Tooltip: React.FC<TooltipProps> = ({
  className,
  place = 'top',
  effect = 'solid',
  ...otherProps
}: TooltipProps) => (
  <ReactTooltip
    className={classNames('vol-tooltip', className)}
    place={place}
    effect={effect}
    {...otherProps}
  />
);

export default Tooltip;
